import { messagesNow } from '@/i18n'
import { messages } from './messages'

// Extract a human-readable message from the 3 backend block-error formats.
// RTK Query surfaces errors as { status, data }; the payload is in `data`.
const defaultFallback = (): string => messagesNow(messages).blockSaveFailed

const isRecord = (v: unknown): v is Record<string, unknown> => typeof v === 'object' && v !== null

// Publish (snake_case): { is_valid, errors: [{ location, message }] }
const parsePublishErrors = (root: Record<string, unknown>): string | null => {
  if (!Array.isArray(root.errors)) return null
  const msgs = root.errors
    .map((e) => (isRecord(e) && typeof e.message === 'string' ? e.message : null))
    .filter((m): m is string => Boolean(m))
  return msgs.length ? msgs.join('; ') : null
}

// Domain: { detail: { code, detail } } / Pydantic 422: { detail: [{ msg }] } / bare string
const parseDetail = (detail: unknown): string | null => {
  if (isRecord(detail) && typeof detail.detail === 'string') return detail.detail
  if (Array.isArray(detail)) {
    const first = detail.find((d) => isRecord(d) && typeof d.msg === 'string')
    if (isRecord(first) && typeof first.msg === 'string') return first.msg
  }
  if (typeof detail === 'string' && detail) return detail
  return null
}

export const parseBlockError = (err: unknown, fallback: string = defaultFallback()): string => {
  const root = isRecord(err) && 'data' in err ? err.data : err
  if (!isRecord(root)) return typeof root === 'string' && root ? root : fallback

  return parsePublishErrors(root) ?? parseDetail(root.detail) ?? fallback
}
